export default function stateReducer(state, action) {
    switch (action.type) {
      case "setRequestID": {
        return {
          ...state,
          requestID: action.requestID,
        };
      }
      case "setError": {
        return {
          ...state,
          error: action.error,
        };
      }
      case "setRequestDetail": {
        return {
          ...state,
          sellerDetail: action.sellerDetail,
          sbrDetail: action.sbrDetail,
          mapCenter: action.mapCenter,
        };
      }
      default: {
        throw Error("Unknown action: " + action.type);
      }
    }
}